import { AppStoreBadges } from '@/components/marketing/AppStoreBadges';

export function DownloadSection() {
  return (
    <section 
      id="download"
      className="bg-gradient-to-br from-brand-500 to-brand-700 text-white py-20"
    >
      <div className="container-default mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-section-title mb-4">
          Stop shoveling. Start living.
        </h2>
        <p className="text-body-lg text-snow-200 mb-8 max-w-2xl mx-auto">
          Join thousands of Canadians who just tap SNOWBLOWR when it dumps outside.
        </p>
        <AppStoreBadges variant="light" />
      </div>
    </section>
  );
}

